module.exports = __webpack_public_path__ + "img/flag-uk.9df98a35.svg";